const colors = [
    { bg: '#fdeef1', fg: '#fa3c69' },
    { bg: '#fff1e9', fg: '#e57c45' },
    { bg: '#efecff', fg: '#412fb6' },
    { bg: '#ecf7ee', fg: '#60ab6b' },
    { bg: '#e9f5ff', fg: '#3e9de9' },
    { bg: '#fdf9ec', fg: '#c8a022' },
]

/** @deprecated */
export const userColors = (id: any) => {
    let hash = 0
    for (let i = 0; i < id.length; i++) {
        hash = (hash << 5) - hash + id.charCodeAt(i)
    }
    return colors[Math.abs(hash) % colors.length]
}
